import { Link } from 'react-router-dom';
import { allArticles, categories } from '@/mocks/articleData';

export default function Articles() {
  const schema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: 'https://echo64.cn/' },
          { '@type': 'ListItem', position: 2, name: '文章中心', item: 'https://echo64.cn/articles' },
        ],
      },
      {
        '@type': 'WebPage',
        name: '喑网91文章中心 - 全部文章与使用指南',
        description: '喑网91文章中心汇集平台全部内容，包括功能介绍、使用指南、版本更新、安全资讯与用户故事。',
        url: 'https://echo64.cn/articles',
      },
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      />
      <div className="min-h-screen bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6 pt-28 pb-16">
          {/* Breadcrumb */}
          <nav className="flex items-center gap-2 text-xs text-foreground-500 mb-8" aria-label="面包屑导航">
            <Link to="/" className="hover:text-primary-600 transition-colors no-underline">首页</Link>
            <i className="ri-arrow-right-s-line text-xs"></i>
            <span className="text-foreground-700 font-medium">文章中心</span>
          </nav>

          <div className="mb-10">
            <h1
              className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              文章中心
            </h1>
            <p className="text-sm md:text-base text-foreground-600">
              浏览喑网91全部文章内容，获取最新的平台资讯、使用指南与行业洞察
            </p>
          </div>

          {/* Category Quick Nav */}
          <div className="flex flex-wrap gap-2 mb-8">
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to="/categories"
                className="px-4 py-2 rounded-full text-xs font-medium bg-background-100 text-foreground-700 hover:bg-background-200 border border-background-200/70 transition-colors no-underline whitespace-nowrap"
              >
                <i className={`${cat.icon} mr-1`}></i>
                {cat.name}
              </Link>
            ))}
          </div>

          {/* All Articles List */}
          <div className="space-y-4">
            {allArticles.map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.slug}`}
                className="flex flex-col sm:flex-row gap-4 p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 no-underline"
              >
                <div className="shrink-0">
                  <div className="w-full sm:w-40 h-28 rounded-lg overflow-hidden bg-background-100">
                    <div className="w-full h-full flex items-center justify-center">
                      <i className={`${article.categoryIcon} text-3xl text-background-300`}></i>
                    </div>
                  </div>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-xs text-primary-600 bg-primary-100 px-2 py-0.5 rounded-full">
                      {article.categoryName}
                    </span>
                    <span className="text-xs text-foreground-400">{article.date}</span>
                    <span className="text-xs text-foreground-400">
                      <i className="ri-time-line mr-0.5"></i>{article.readTime}
                    </span>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-900 mb-1.5 group hover:text-primary-600 transition-colors">
                    {article.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                    {article.excerpt}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}